module.exports = __webpack_public_path__ + "img/blog-7.2066f355.jpg";